<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số đề nghị:
                                    {{ createItem.requestNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Khu nuôi: {{ areaCode }}
                                </p>
                                <div>
                                    <v-select
                                        :items="lstAssetsName"
                                        label="Chọn tên tài sản"
                                        v-model="createItem.assetsNameId"
                                        item-value="categoryId"
                                        item-text="categoryName"
                                    />
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <div>
                                    <i-datepicker
                                        label="Ngày xuất kho yêu cầu"
                                        v-model="createItem.exportDate"
                                        :minDate="minDate()"
                                        @change="onChangeExportDate()"
                                    />
                                </div>
                                <p class="font-weight-bold">
                                    Vụ nuôi: {{ cropName }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Người đề nghị xuất kho:
                                    {{ createItem.userCreateName }}
                                </p>
                                <p class="font-weight-bold">
                                    Ngày tuổi tôm: {{ createItem.shrimpAge }}
                                </p>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap>
                        <v-flex md4 style="padding: 10px">
<!--                            <p>-->
<!--                              <v-autocomplete-->
<!--                                  :items="lstMaterialTypeAlly"-->
<!--                                  label="Chọn nhóm của nhóm vật tư"-->
<!--                                  v-model="createItem.materialTypeAllyId"-->
<!--                                  item-value="categoryId"-->
<!--                                  item-text="categoryName"-->
<!--                                  @change="changeMaterialTypeAlly"-->
<!--                                  clearable-->
<!--                              />-->
<!--                            </p>-->
                            <v-btn v-if="!isExportReturn" color="primary" @click="showSelectMaterial">
                                Chọn vật tư
                            </v-btn>
                        </v-flex>
                        <v-flex md8 style="padding: 10px">
                            <v-textarea
                                outlined
                                v-validate="'max:500'"
                                label="Ghi chú"
                                rows="2"
                                v-model="createItem.content"
                                name="request_content"
                                data-vv-as="Ghi chú"
                                :error-messages="errors.first('request_content')"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th>{{$t('lang.material.materialType')}}</th>
                                    <th>Tên vật tư</th>
                                    <th width="150">Đơn vị</th>
                                    <th width="150">Tồn kho</th>
                                    <th width="150">Số lượng cần xuất</th>
                                    <th>Mục đích sử dụng</th>
                                    <th v-if="!isExportReturn" width="100">{{$t('lang.common.delete')}}</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr :key="'mat'+index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td>{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.inventory | currency }}</td>
                                        <td>
                                          <c-input-number
                                              v-model="lstMaterial[index].total_export"
                                              v-on:input="setInput"
                                              @keydown="keyProcess"
                                              @change="onInputChange"
                                              :id="'input_' + index + '_' + 0"
                                              :data-row="index"
                                              :data-col="0"
                                              styles="text-align: right; width: 100px;outline: none;"
                                              :disabled="item.inventory == 0 ? true : false"
                                          />
                                        </td>
                                        <td>
                                            <v-textarea
                                                rows="2"
                                                v-model="lstMaterial[index].content"
                                                @keydown="keyProcess"
                                                :id="'input_' + index + '_' + 1"
                                                :data-row="index"
                                                :data-col="1"
                                            />
                                        </td>
                                        <td v-if="!isExportReturn" style="text-align: center">
                                            <v-btn icon @click="deleteItem(item)">
                                                <v-icon color="red">delete</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onSave" :disabled="loading">
                        {{ $t("Tạo phiếu") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <material-list
            :cDialog="materialDlg"
            @select="onSelectMaterial"
            :lstSelectedMaterial="lstMaterial"
            :materialTypeAllyId="createItem.materialTypeAllyId"
            @closeDialog="closeMaterialListDialog"
            :reload="reload"
        />
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import { areaContants } from "@/constants";
import MaterialList from "./component/MaterialList";
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "NotProcessCreate",
    components: {CTextboxFloat, IDatepicker, MaterialList },
    data: () => {
        return {
            formName: "Tạo đề nghị xuất kho không theo quy trình",
            loading: false,
            cropName: '',
            areaCode: '',
            crop: '',
            lstMaterialType: [],
            lstMaterial: [],
            lstMaterialPrice: [],
            lstAssetsName: [],
            materialDlg: false,
            isExportReturn: false,
            importWh: null,
            importRequestId: 0,
            // lstMaterialTypeAlly:[],
            createItem: {
                requestNumber: '',
                userCreateId: '',
                userCreateName: '',
                cropId: '',
                exportType: 2,
                shrimpAge: '',
                warehouseId: '',
                assetsNameId: '',
            },
            reload:0
        };
    },

    watch : {
        lstMaterial: {
          handler(value) {
              // console.log("ttt",value);
          },
          deep: true
        }

    },

    created() {
        // 4: kỹ sư trưởng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role == 4) {
            this.createItem.status = 2;
        } else {
            this.createItem.status = 1;
        }
        
        this.createItem.userCreateId = this.$store.state.auth.user.userId;
        this.createItem.userCreateName = this.$store.state.auth.user.fullName;
        this.createItem.exportDate = moment().format('YYYY-MM-DD');
        
        this.getNextCode();

        let queryParam = this.$route.query;
        if (queryParam.importId != undefined) {
            this.isExportReturn = true;
            let importId = queryParam.importId;
            this.getImportWh(importId);
        } else {
            this.getCrop(this.$route.params.id);
        }
        
        this.getMaterialType();
        this.getAssetsName();
        // this.getMaterialTypeAlly();
    },

    methods: {
        //linhdx reload lai array thi moi hien thi dc c-textbox-float
        setInput(){
          this.lstMaterial = [...this.lstMaterial]
        //   console.log(this.lstMaterial)
        },
        // getMaterialTypeAlly() {
        //   axios.post(
        //       process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE_ALLY"
        //   ).then(
        //       (data) => {
        //         if (data.length > 0) {
        //           this.lstMaterialTypeAlly = data;
        //         }
        //       }
        //   );
        // },
        // changeMaterialTypeAlly(){
        //     this.lstMaterial = new Array();
        //     this.reload = Math.random()
        // },
        onCancel() {
            //this.$router.push({ path: '/exportRequest' });
            const query = this.$route.query;

            if (query.importId != undefined) {
                this.$router.push({ path: '/importRequest/importWhView/' + this.importRequestId, query: query});
            } else {
                query.activeTab = 2;
                this.$router.push({ path: `/exportRequest`, query: query });
            }
        },
        onSave() {
            if(this.lstMaterial.length < 1){
                message.error("Không có vật tư");
                return;
            }

            const lstMaterial_tmp = this.lstMaterial;
            let rt = true;

            $.each(lstMaterial_tmp, function (k, v) {
                if (parseFloat(v.inventory) > 0) {
                    if (v.total_export === '') {
                        message.error("Có vật tư chưa nhập số lượng xuất kho");
                        rt = false;
                    }
                    if (parseFloat(v.total_export) > parseFloat(v.inventory)) {
                        message.error("Tổng đề xuất không được vượt quá số lượng tồn kho");
                        rt = false;
                    }
                }

                lstMaterial_tmp[k].amount = parseFloat(lstMaterial_tmp[k].total_export) * parseFloat(lstMaterial_tmp[k].price);
            });
            if(!rt){
              return;
            }
        
            const createItem = this.createItem;
            createItem.requestData = JSON.stringify(lstMaterial_tmp);
            // console.log(createItem);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success(
                                this.$t("lang.common.save_success")
                            );
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                        }
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        getCrop(cropId) {
            axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
                    {cropId: cropId}
                )
                .then((data) => {
                    if (data.items.length > 0) {
                        this.createItem.areaId = data.items[0].pondAreaId;
                        this.createItem.cropId = data.items[0].cropId;
                        this.createItem.procedureId = data.items[0].processId;
                        this.crop = data.items[0];
                        this.cropName = data.items[0].name;
                        
                        this.getPondArea(data.items[0].pondAreaId);
                        this.getShrimpAge();
                    }
                });
        },
        getPondArea(areaId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
                {categoryId: areaId}
            )
            .then((data) => {
                if (data.items) {
                    this.areaCode = data.items[0].categoryName;
                    this.getWarehouse(data.items[0].categoryId);
                }
            });
        },
        getAssetsName() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=ASSETS_NAME&pageSize=-1&page=-1",
                {}
            )
            .then((data) => {
                if (data.items) {
                    this.lstAssetsName = data.items;
                }
            });
        },
        getWarehouse(parentId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&pageSize=-1&page=-1",
                {parentId: parentId}
            )
            .then((data) => {
                if (data.items) {
                    this.createItem.warehouseId = data.items[0].categoryId;
                    this.getMaterialPrice(data.items[0].categoryId);
                    this.getWarehouseInventory(data.items[0].categoryId);
                }
            });
        },
        getWarehouseInventory(warehouseId) {
            axios.post(
                    process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
                    {warehouseId: warehouseId}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstInventory = data.items;
                        this.reCalculate();
                    }
                });
        },
        getMaterialType() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
            ).then(
                (data) => {
                    if (data.length > 0) {
                        this.lstMaterialType = data;
                    }
                }
            );
        },
        getNextCode() {
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        "/autoIncrease/getNextCode?type=ĐNX&prefix=ĐNX/&numberZeroBeforeCodeNumberCode=2&suffix="
                )
                .then((data) => {
                    this.createItem.requestNumber = data;
                });
        },
        keyProcess($event) {
            // console.log(this.lstMaterial);
            let group = 'input';
            let row = parseInt($event.target.getAttribute("data-row"));
            let col = parseInt($event.target.getAttribute("data-col"));
            switch ($event.keyCode) {
                case 13:
                    col += 1;
                    let id = group + '_' + row + '_' + col;
                    var element = document.getElementById(id);
                    // console.log();
                    if (typeof (element) != 'undefined' && element != null) {
                        element.focus();
                    } else {
                        row += 1;
                        col = 0;
                        id = group + '_' + row + '_' + col;
                        let element2 = document.getElementById(id);
                        if (typeof (element2) != 'undefined' && element2 != null) {
                            element2.focus();
                        } else {
                            document.getElementById($event.target.getAttribute("id")).blur();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 37:
                    // left
                    if (col >= 0) {
                        col -= 1;
                        let id = group + '_' + row + '_' + col;
                        let element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (row >= 0) {
                        row -= 1;
                        let id = group + '_' + row + '_' + col;
                        let element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 39:
                    //right
                    if (col >= 0) {
                        col += 1;
                        let id = group + '_' + row + '_' + col;
                        // document.getElementById(id).focus();
                        var element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    if (row >= 0) {
                        row += 1;
                        let id = group + '_' + row + '_' + col;
                        var element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        getShrimpAge(calcuDate = '') {
            const item = this.crop;
            if (item == '') {
                return 0;
            }
            let calculateDate = calcuDate != '' ? calcuDate : moment().format('YYYY-MM-DD');
            
            let shrimpAge = '';
            let dropDate = '';
            if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
                dropDate = moment(String(item.dropDateParent));
            } else if (item.dropDate != '' && item.dropDate != null) {
                dropDate = moment(String(item.dropDate));
            }
            if (dropDate != '') {
                let calculateDateMM = moment(String(calculateDate));
                let endDate = moment(String(calculateDate));
                if (item.endDate) {
                    endDate = moment(String(item.endDate));
                    if (endDate > calculateDateMM) endDate = calculateDateMM;
                }
                if (endDate > dropDate) {
                    let dates = endDate.diff(dropDate, "days");
                    if (dates >= 0) {
                        shrimpAge = dates;
                    }
                }
            }
            this.createItem.shrimpAge = shrimpAge;
        },
        reCalculate() {
            console.log(this.lstMaterial);
            for (let i = 0; i < this.lstMaterial.length; i++) {
                if (this.isExportReturn) {
                    this.lstMaterial[i].total_export = this.lstMaterial[i].quantity;
                } else if (this.lstMaterial[i].total_export == undefined) {
                    this.lstMaterial[i].total_export = '';
                }
                
                if (this.lstMaterial[i].inventory == undefined) {
                    this.lstMaterial[i].inventory = 0;
                }
                if (this.lstMaterial[i].price == undefined) {
                    this.lstMaterial[i].price = 0;
                }
                if (this.lstMaterial[i].amount == undefined) {
                    this.lstMaterial[i].amount = 0;
                }
                this.lstMaterial[i].row = 0;
            }

            //
            // sort by typeId
            //
            this.lstMaterial.sort((o1, o2) => {
                if (o1.typeId == o2.typeId) {
                    return o1.materialName.localeCompare(o2.materialName);
                } else {
                    return o1.typeId - o2.typeId;
                }
            })
            //linhdx reset het row material = ""
            for (let j = 0; j < this.lstMaterial.length; j++) {
              this.lstMaterial[j].row = null;
            }
            for (let i = 0; i < this.lstMaterialType.length; i++) {
                this.lstMaterialType[i].count = 0;
                for (let j = 0; j < this.lstMaterial.length; j++) {
                    if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                        this.lstMaterialType[i].count++;
                    }
                }
                if (this.lstMaterialType[i].count != 0) {
                    for (let j = 0; j < this.lstMaterial.length; j++) {
                        if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                            this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
                            this.lstMaterial[j].row = this.lstMaterialType[i].count;
                            break;
                        }
                    }
                }
            }
            // console.log(this.lstMaterial);
            // inventory
            const lstInventory = this.lstInventory;
            const lstMaterial = this.lstMaterial;
            if (lstInventory != undefined && lstMaterial != undefined) {
                for (let i = lstMaterial.length - 1; i >= 0; i--) {
                    const inv = lstInventory.filter(function(o) {
                        return lstMaterial[i].materialId == o.materialId;
                    });
                    if (inv != undefined && inv[0] != undefined) {
                        lstMaterial[i].inventory = inv[0].quantity;
                    }

                    // material price
                    lstMaterial[i].price = 0;
                    const matPrice = this.lstMaterialPrice.find((v) => v.materialId === lstMaterial[i].materialId);
                    if (matPrice != undefined) {
                        lstMaterial[i].price = matPrice.averagePrice;
                    }
                }
            }
            
            this.lstMaterial = lstMaterial;
        },
        onChangeExportDate() {
            this.getShrimpAge(this.createItem.exportDate);
            this.reCalculate();
        },
        onSelectMaterial(lstSelectMaterial) {
            for (let j = this.lstMaterial.length-1;j>=0; j--) {
                let bHas = false;
                for (let i = 0; i < lstSelectMaterial.length; i++) {
                    if (this.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
                        bHas = true;
                        break;
                    }
                }
                if(!bHas){
                    this.lstMaterial.splice(j);
                }
            }
            for (let i = 0; i < lstSelectMaterial.length; i++) {
                let bHas = false;
                for (let j = 0; j < this.lstMaterial.length; j++) {
                    if (this.lstMaterial[j].materialId == lstSelectMaterial[i].materialId) {
                        bHas = true;
                        break;
                    }
                }
                if (!bHas) {
                    lstSelectMaterial[i].row = "";
                    this.lstMaterial.push(lstSelectMaterial[i]);
                }
            }
            this.reCalculate();
        },
        closeMaterialListDialog() {
            this.materialDlg = false;
        },
        showSelectMaterial() {
          this.materialDlg = true;
          // if (this.isNullOrEmpty(this.createItem.materialTypeAllyId)){
          //   message.error("Chưa chọn nhóm của nhóm vật tư");
          //   return;
          // } else{
          //   this.materialDlg = true;
          // }
        },
        deleteItem(item){
            if(confirm("Bạn có chắc xóa vật tư "+ item.materialName + " khỏi đề nghị xuất hàng không?")){
                for(let i = 0; i < this.lstMaterial.length; i++){
                    if(this.lstMaterial[i].materialId == item.materialId){
                        this.lstMaterial.splice(i,1);
                        break;
                    }
                }
                this.reCalculate();
            }
        },
        getMaterialPrice(warehouseId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/materialPrice/search?pageSize=-1&page=-1", {warehouseId: warehouseId}
            )
                .then((data) => {
                    if (data.items) {
                        this.lstMaterialPrice = data.items;
                    }
                });
        },
        onInputChange($event) {
            const row = parseInt($event.target.getAttribute("data-row"));
            this.lstMaterial[row].amount = parseFloat($event.target.value) * this.lstMaterial[row].price;
        },
        getImportWh(importId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/importWh/detail/" + importId
            )
                .then((data) => {
                    if (data != undefined) {
                        console.log(data);
                        this.importWh = data;
                        this.createItem.importWhId = data.importId;
                        this.createItem.areaId = data.areaId;
                        this.importRequestId = data.importRequestId;
                        this.lstMaterial = JSON.parse(data.requestData);
                        this.getMaterialPrice(data[0].warehouseId);
                        // this.getImportRequest(data[0].importRequestId);
                        this.getPondArea(data.areaId);
                        // this.getWarehouses(data[0].warehouseId);
                        this.reCalculate();
                        // this.setLstMaterial();
                    }
                });
            },
    },

    destroyed() {},
};
</script>
